export default "__VITE_ASSET__vs9kkgzj__"